import React from 'react';
import { useHistory } from 'react-router-dom';
import { useUserApi } from 'services/user-service';
import { Container, Overlay, FormTextInput, Text } from 'routes/auth/style';
import { H2 } from 'components/typography';
import Form from 'components/form';
import ForgotPasswordSuccessModal from 'routes/auth/forgot-password/components/forgot-password-success-modal';
import { useTranslation } from 'i18n';
import { object, string } from 'yup';
import { WithMargin } from 'components/layout';
import { typography } from 'styles/settings';
import toast from 'services/toast';

function createValidationSchema(t) {
  return function () {
    return object().shape({
      email: string()
        .email(t('Invalid email format'))
        .required(t('Email is required.')),
    });
  };
}

function Register() {
  const modal = React.useRef<any>(null);

  const { t } = useTranslation();
  const userApi = useUserApi();
  const history = useHistory();

  function onSubmit({ email }) {
    return userApi.forgotPassword(email).then(async (response) => {
      if (response.isSuccess) {
        modal.current.show();
      }
    });
  }

  const initialValues = {
    email: '',
  };

  const validationSchema = createValidationSchema(t);

  return (
    <>
      <ForgotPasswordSuccessModal
        ref={modal}
        style={{ maxWidth: '780px' }}
        onBeforeHide={() => history.push('/login')}
      />
      <Overlay>
        <Container>
          <WithMargin bottom={typography.size.ml}>
            <H2>{t('Reset password')}</H2>
          </WithMargin>
          <WithMargin bottom={typography.size.md}>
            <Text>
              {t('Please enter your email address used during registration')}
            </Text>
          </WithMargin>
          <Form
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>
            {(form) => (
              <>
                <FormTextInput name="email" placeholder={t('E-Mail')} />

                <Form.SubmitButton
                  label={t('Reset password')}
                  onClick={form.handleSubmit}
                />
              </>
            )}
          </Form>
        </Container>
      </Overlay>
    </>
  );
}

export default Register;
